export const SUBSCRIPTION_TIERS = {
  BASIC: 'Basic',
  STANDARD: 'Standard',
  PREMIUM: 'Premium',
}

export const MERCHANT_NAME = 'Sokooni E-Commerce Ltd'

export const SUBSCRIPTION_WARNING_THRESHOLDS = {
  CRITICAL: 0,
  WARNING: 7,
}

export const SUBSCRIPTION_STATUS_OPTIONS = [
  { value: '', label: 'All Status' },
  { value: 1, label: 'Active' },
  { value: 0, label: 'Inactive' },
]
